import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center btn-group-border" }
const _hoisted_2 = {
  class: "tooltip",
  "data-tip": "Download firmware configuration file in JSON format"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  class: "tooltip",
  "data-tip": "Load firmware configuration from uploaded JSON file"
}

import { useToast } from "vue-toastification";
import { useBackendStore, useKeyboardStore } from "@/stores";
import FileUpload from "@/components/utils/FileUpload.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigUpDownloadButton',
  setup(__props) {

const toast = useToast();
const backend = useBackendStore();
const kb = useKeyboardStore();

const formatDateTime = (d: Date) => {
  const d2 = (num: number) =>
    num.toString().length == 1 ? "0" + num.toString() : num.toString();
  const date = `${d.getFullYear()}${d2(d.getMonth() + 1)}${d2(d.getDate())}`;
  const time = `${d2(d.getHours())}${d2(d.getMinutes())}${d2(d.getSeconds())}`;
  return `${date}_${time}`;
};

const downloadJSON = () => {
  const final = backend.currentConfigFinal;
  if (final == null) return;

  // Prepare data
  const data = final.config;
  const uri =
    "data:application/json;charset=utf-8," +
    encodeURIComponent(JSON.stringify(data));
  const fileName =
    [
      final.name,
      ...(backend.configModified ? ["modified"] : []),
      formatDateTime(new Date(Date.now())),
    ].join("__") + ".json";
  // Create virtual hyperlink
  const anchor = document.createElement("a");
  anchor.setAttribute("href", uri);
  anchor.setAttribute("download", fileName);
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

const uploadJSON = (file: File, data: ArrayBuffer | string) => {
  kb.setConfig(JSON.parse(data as string));
  if (backend.currentConfig != null) backend.currentConfig.name = file.name;
  toast.success("Loaded configuration from file");
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: downloadJSON,
        class: "btn btn-neutral btn-group-start",
        disabled: _unref(backend).currentConfig == null
      }, [
        _createVNode(_component_Icon, {
          icon: "ic:baseline-download",
          class: "text-lg"
        })
      ], 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(FileUpload, {
        class: "btn-group-end",
        accept: "application/json",
        method: "readAsText",
        disabled: _unref(backend).currentConfig == null,
        onLoaded: uploadJSON
      }, null, 8, ["disabled"])
    ])
  ]))
}
}

})